const main = () => {
    const toggles = document.querySelectorAll('.js-drawer-toggle');
    const drawer = document.getElementById('l-header-drawer');
    const closers = document.querySelectorAll('.js-drawer-close');
    if (!drawer || toggles.length === 0) return;

    const open = () => {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        toggles.forEach((t) => {
            t.setAttribute('aria-expanded', 'true');
            t.setAttribute('aria-label', 'メニューを閉じる');
        });
        document.body.style.overflow = 'hidden';
    };

    const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        toggles.forEach((t) => {
            t.setAttribute('aria-expanded', 'false');
            t.setAttribute('aria-label', 'メニューを開く');
        });
        document.body.style.overflow = '';
    };

    const isOpen = () => drawer.classList.contains('is-open');

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            isOpen() ? close() : open();
        });
    });

    closers.forEach((closer) => {
        closer.addEventListener('click', (e) => {
            e.preventDefault();
            close();
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen()) close();
    });
};

export default main;
